"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var reDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createRe: _factoriesAny.createRe
};
exports.reDependencies = reDependencies;